function _classCallCheck(instance, Constructor) {
  if (!(instance instanceof Constructor)) {
    throw new TypeError("Cannot call a class as a function");
  }
}

function _defineProperties(target, props) {
  for (var i = 0; i < props.length; i++) {
    var descriptor = props[i];
    descriptor.enumerable = descriptor.enumerable || false;
    descriptor.configurable = true;
    if ("value" in descriptor) descriptor.writable = true;
    Object.defineProperty(target, descriptor.key, descriptor);
  }
}

function _createClass(Constructor, protoProps, staticProps) {
  if (protoProps) _defineProperties(Constructor.prototype, protoProps);
  if (staticProps) _defineProperties(Constructor, staticProps);
  return Constructor;
}

var Time =
/*#__PURE__*/
function () {
  function Time() {
    _classCallCheck(this, Time);
  }

  _createClass(Time, null, [{
    key: "render",
    value: function render() {
      Time.renderTimeTag();
      Time.renderTimeRangeTag();
    }
    /**
     * Render a iso date string using browser time zone.
     * @param {string} isoDate The iso date string in the format yyyy-MM-dd'T'HH:mm:ss.SSS'Z'
     * @param {string} format Possible values for the format are:
     *                   * D - Shows Day
     *                   * M-NUMERIC - Shows Month in Numeric Form
     *                   * MD - Shows Day and Month
     *                   * MMMM-Do - Shows full month and day with ordinal suffix (eg. December 12th)
     *                   * MDY - Shows Day, Month and Year
     *                   * FULL - Shows Day, Month, Year, Hour, Second and Timezone
     */

  }, {
    key: "renderDate",
    value: function renderDate(isoDate, format) {
      if (!isoDate) return;

      switch (format) {
        case "D":
          return new Date(isoDate).toLocaleDateString("en-us", {
            day: "numeric"
          });

        case "M-NUMERIC":
          return new Date(isoDate).toLocaleDateString("en-us", {
            month: "numeric"
          });

        case "MD":
          return new Date(isoDate).toLocaleDateString("en-us", {
            month: "short",
            day: "numeric"
          });

        case "MMMM-Do":
          return Time._formatMMMMDo(isoDate);

        case "MDY":
          return new Date(isoDate).toLocaleDateString("en-us", {
            month: "short",
            day: "numeric",
            year: "numeric"
          });

        case "FULL":
          return new Date(isoDate).toLocaleDateString("en-us", {
            timeZoneName: "short",
            month: "short",
            day: "numeric",
            year: "numeric",
            hour12: true,
            hour: "numeric",
            minute: "2-digit"
          });

        case "H":
          return new Date(isoDate).toLocaleTimeString("en-us", {
            hour12: true,
            hour: "numeric"
          });

        case "HT":
          return new Date(isoDate).toLocaleTimeString("en-us", {
            timeZoneName: "short",
            hour12: true,
            hour: "numeric"
          });

        default:
          return new Date(isoDate).toLocaleDateString("en-us", {
            timeZoneName: "short",
            month: "short",
            day: "numeric",
            year: "numeric",
            hour12: true,
            hour: "numeric",
            minute: "2-digit"
          });
      }
    }
    /**
     * Method to render dates for <date> tags
     */

  }, {
    key: "renderTimeTag",
    value: function renderTimeTag() {
      var dateDoms = document.querySelectorAll("date");

      if (dateDoms && dateDoms.length) {
        for (var i = 0; i < dateDoms.length; i++) {
          var dateDom = dateDoms[i];
          var isoDate = dateDom.getAttribute("data-date");
          var format = dateDom.getAttribute("data-format");

          if (isoDate && format) {
            dateDom.innerHTML = Time.renderDate(isoDate, format);
          }
        }
      }
    }
    /**
     * Render <date-range> tag
     */

  }, {
    key: "renderTimeRangeTag",
    value: function renderTimeRangeTag() {
      var dateRangeDoms = document.querySelectorAll("date-range");

      if (dateRangeDoms && dateRangeDoms.length) {
        for (var i = 0; i < dateRangeDoms.length; i++) {
          var dateRangeDom = dateRangeDoms[i];
          var startDateIso = dateRangeDom.getAttribute("data-start-date");
          var endDateIso = dateRangeDom.getAttribute("data-end-date");

          if (startDateIso && endDateIso) {
            dateRangeDom.innerHTML = Time.formatDateRange(startDateIso, endDateIso);
          }
        }
      }
    }
    /**
     * Will return something like:
     * Feb 21st - 23rd
     * Feb 27th - Mar 3rd
     * If same month then the second date string will not show month, else otherwise
     * return string
     * @param {string} startDateIso 
     * @param {string} endDateIso 
     */

  }, {
    key: "formatDateRange",
    value: function formatDateRange(startDateIso, endDateIso) {
      var startDateText = Time.renderDate(startDateIso, "MD");
      var endDateText = "";

      if (Time.renderDate(startDateIso, "M-NUMERIC") != Time.renderDate(endDateIso, "M-NUMERIC")) {
        endDateText = Time.renderDate(endDateIso, "MD");
      } else {
        endDateText = Time.renderDate(endDateIso, "D");
      }

      return "".concat(startDateText).concat(Time._addNth(Time.renderDate(startDateIso, "D")), " - ").concat(endDateText).concat(Time._addNth(Time.renderDate(endDateIso, "D")));
    }
    /**
     * Will return a date range with the year included:
     * Nov 24 - Dec 3, 2018
     * Dec 23, 2018 - Jan 9, 2019
     * 
     * @param {string} startDateIso 
     * @param {string} endDateIso 
     */

  }, {
    key: "formatDateRangeWithYear",
    value: function formatDateRangeWithYear(startDateIso, endDateIso) {
      var startDate = Time.renderDate(startDateIso, 'MDY');
      var endDate = Time.renderDate(endDateIso, 'MDY');
      var etaStartParts = startDate ? startDate.split(',') : [];

      if (etaStartParts && etaStartParts.length > 1 && endDate.endsWith(etaStartParts[1])) {
        // Remove the year from the ETA start if the year is the same as the ETA end
        startDate = etaStartParts[0];
      }

      return "".concat(startDate, " - ").concat(endDate);
    }
  }, {
    key: "_addNth",
    value: function _addNth(number) {
      number = Time._removeEmptyString(number);

      if (number > 3 && number < 21) {
        return "th";
      } else {
        switch (number % 10) {
          case 1:
            return "st";

          case 2:
            return "nd";

          case 3:
            return "rd";

          default:
            return "th";
        }
      }
    }
  }, {
    key: "_removeEmptyString",
    value: function _removeEmptyString(number) {
      if (typeof number == "number") {
        number = number.toString().trim();
      }

      var arrStrings = number.split("");
      var arr = [];

      for (var i = 0; i < arrStrings.length; i++) {
        if (!Number.isNaN(parseInt(arrStrings[i]))) {
          arr.push(arrStrings[i]);
        }
      }

      return arr.join("");
    }
  }, {
    key: "_formatMMMMDo",
    value: function _formatMMMMDo(isoDate) {
      var month = new Date(isoDate).toLocaleDateString("en-us", {
        month: "long"
      });
      var day = new Date(isoDate).toLocaleDateString("en-us", {
        day: "numeric"
      });
      return "".concat(month, " ").concat(day).concat(Time._addNth(day));
    }
  }]);

  return Time;
}();

export default Time;
